import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SearchComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SearchComponent implements OnInit, ControlValueAccessor {
  @ViewChild('inputRef', { static: false }) inputRef!: ElementRef;
  @Input() searchType: 'default' | 'transparent' | 'cancel' | 'chats' = 'default';
  @Input() label: string = '';
  @Input() customClass: string = '';
  // @Input() placeholder: string = 'Пошук...';
  @Input() disabled: boolean = false;
  @Input() autoFocus: boolean = false;
  @Input() clearVisibility: boolean = false;
  @Input() loading: boolean = false;
  @Input() arrows: boolean = false;
  @Input() input: string = '';
  @Output() onChangeClick = new EventEmitter();
  @Output() onChangeSave = new EventEmitter();
  @Output() onChangeCancel = new EventEmitter();
  @Output() onValueChange = new EventEmitter<string>();
  @Output() onClearChange = new EventEmitter();
  @Output() onArrowUpClick = new EventEmitter();
  @Output() onArrowDownClick = new EventEmitter();
  copyInput: string = '';

  ngOnInit(): void {
    if (this.autoFocus) {
      setTimeout(() => this.inputRef.nativeElement.focus());
    }
  }

  onChange = (data: any) => {};
  onTouch = (_: any) => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(value: string) {
    this.input = value;
    this.onChange(value);
  }

  /**
   *Func triggered on input change
   */
  onchange(event: any) {
    if (event.trim() !== '' || event === '') {
      this.input = event;
      this.onChange(event);
      this.onValueChange.emit(event);
    }
  }

  clear() {
    this.onClearChange.emit();
    this.onchange('');
  }

  protected keepFocus(event: MouseEvent) {
    event.preventDefault();
    this.inputRef.nativeElement.focus();
  }

  protected arrowUpClick(event: MouseEvent) {
    event.stopPropagation();
    this.inputRef.nativeElement.blur();
    this.onArrowUpClick.emit();
  }

  protected arrowDownClick(event: MouseEvent) {
    event.stopPropagation();
    this.inputRef.nativeElement.blur();
    this.onArrowDownClick.emit();
  }
}
